import React, { FC } from 'react';

interface ChevronProps {
  classes?: string;
  color?: string;
  direction?: 'up' | 'down' | 'left' | 'right';
  height?: number;
  width?: number;
  strokeWidth?: number;
  onClick?: () => void;
}

const ChevronIcon: FC<ChevronProps> = ({
  classes = '',
  color = 'charcoal',
  direction = 'down',
  height = 16,
  width = 16,
  strokeWidth = '2',
  onClick = () => null,
}) => {
  let path = '';
  let viewBox = '';
  // svg paths sourced from exported figma arrow icons
  switch (direction) {
    case 'up':
      path = 'M13 7.3418L7 1.3418L1 7.3418';
      viewBox = '0 0 15 9';
      break;
    case 'down':
      path = 'M1 0.999999L7 7L13 1';
      viewBox = '0 0 15 9';
      break;
    case 'left':
      path = 'M7 1L1 7L7 13';
      viewBox = '0 0 10 15';
      break;
    case 'right':
      path = 'M1 13L7 7L1 1';
      viewBox = '0 0 10 15';
      break;
  }

  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`stroke-${color} ${classes} flex items-center`}
      viewBox={viewBox}
      data-testid="chevron-icon"
    >
      <path
        fill="none"
        d={path}
        stroke={`currentColor`}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronIcon;
